import React from "react";
import { FormContainer } from "./style";
import SelectedProduct from "components/selectedProduct";
import Profile from "components/profile";
import Button from "components/button";
const FormView = ({ nextStep, prev, product, selectedOptions,showPic }) => {
  return (
    <FormContainer>
        <div className="title">
          <h5>تکمیل اطلاعات</h5>
        </div>
        <SelectedProduct showPic={showPic} selectedOptions={selectedOptions} product={product} />
        <Profile nextStep={nextStep} />
        <div className="prev">
          <Button title="مرحله قبل" onClick={prev} />
        </div>
    </FormContainer>
  );
};
export default FormView;
